import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Typography, Button, Alert,
  useMediaQuery, useTheme
} from '@mui/material';

export default function TempPasswordDialog({
  open, onClose,
  employeeName, password
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog open={open} onClose={onClose} fullScreen={isMobile}>
      <DialogTitle>Employee Created Successfully</DialogTitle>
      <DialogContent>
        <Typography gutterBottom>
          <strong>{employeeName}</strong> has been created.
        </Typography>
        <Alert severity="info" sx={{ mt: 2 }}>
          <Typography variant="body2" gutterBottom>
            <strong>Temporary Password:</strong>
          </Typography>
          <Typography variant="h6" sx={{ fontFamily: 'monospace', bgcolor: 'grey.100', p: 1, borderRadius: 1 }}>
            {password}
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            The employee will be required to change this password on first login.
            {' '}An email notification has been sent (if email is configured).
          </Typography>
        </Alert>
      </DialogContent>
      <DialogActions sx={{ p: isMobile ? 2 : 1 }}>
        <Button variant="contained" onClick={onClose} size={isMobile ? 'large' : 'medium'}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
